<template>
  <div class="bg">
    <div class="literature-search">
      <div class="logo_desc">
        文献检索：精准检索外文学术论文
        <div style="display: inline-block">
          <el-popover placement="top-start" width="285" trigger="hover" :content="tipsContent">
            <el-button slot="reference" type="text" icon="el-icon-info" style="color: #ccc; font-size: 18px"></el-button>
          </el-popover>
        </div>
      </div>
      <div class="item-one page1">
        <div class="flex">
          <el-input type="textarea" placeholder="请输入要检索的内容" v-model="keyword" :autosize="{ minRows: 4, maxRows: 8 }" maxlength="100" @keyup.enter.native="toSearch" @input="getKeywordData(1)" @focus="showSearchInput" @blur="hideSearchInput" clearable></el-input>
        </div>
        <div :class="keyword.trim() ? 'search-btn search-btn-active' : 'search-btn search-btn-disabled'" @click="toSearch">
          <span class="dp-build-icon" style="display: inline-flex; justify-content: center; align-items: center; font-size: 36px">
            <svg fill="none" viewBox="0 0 36 36" width="1em" height="1em">
              <circle cx="18" cy="18" r="18" :fill="keyword.trim() ? 'currentColor' : '#ccc'"></circle>
              <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 24.67V11.33m0 0-5 5m5-5 5 5"></path>
            </svg>
          </span>
        </div>
      </div>
      <div class="hot">
        <ul>
          <li v-for="(item, index) in hotList" :key="index">
            <span @click="toHotSearch(item)">{{ item }}</span>
          </li>
        </ul>
      </div>
      <!-- <div class="search-input" v-if="searchFlag" @click.stop>
        <ul>
          <li v-for="(item, index) in keywordDataList" :key="index" @click="toSearchKeyword(index)">
            <i class="el-icon-search"></i>
            <span v-safe-html="item.suggestionWord"></span>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "LiteratureSearch",
  props: {
    tabIndex: {
      type: Number,
      default: 1,
    },
    externalKeyword: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      keyword: "",
      searchFlag: false,
      keywordDataList: [],
      selectVal: "",
      hotList: [],
      tipsContent: "",
      loginRedirecting: false,
      searchPaperOptions: [
        { label: "全部", value: null },
        { label: "题名", value: "title" },
        { label: "DOI", value: "doi" },
        { label: "作者", value: "author" },
        { label: "关键词", value: "hingeWord" },
      ],
      paper: "",
    };
  },
  watch: {
    externalKeyword(newVal) {
      if (newVal) {
        this.keyword = newVal;
      }
    },
  },
  mounted() {
    this.getTips();
    this.getHotList();
  },
  methods: {
    hasLoginToken() {
      return !!localStorage.getItem("token") || !!localStorage.getItem("jyx_token");
    },
    redirectToUnifiedLogin() {
      if (this.loginRedirecting) {
        return;
      }
      this.loginRedirecting = true;
      const authorizationUrl = `${window.location.origin}/back/oauth/get_authorization_url`;
      this.$http
        .get(authorizationUrl)
        .then(res => {
          const authUrl = res && res.data && res.data.auth_url ? res.data.auth_url : "";
          if (!authUrl) {
            throw new Error("Missing auth url");
          }
          const urlObj = new URL(authUrl);
          const clientId = urlObj.searchParams.get("client_id");
          const redirectUri = encodeURIComponent(urlObj.searchParams.get("redirect_uri"));
          const state = urlObj.searchParams.get("state");
          const orgUrl = `https://sso.cxstar.cn/oauth/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}&response_type=code`;
          window.location.href = orgUrl;
        })
        .catch(() => {
          this.loginRedirecting = false;
          window.open("/lg?word=true", "_self");
        });
    },
    ensureLoginBeforeSearch() {
      if (this.hasLoginToken()) {
        return true;
      }
      this.redirectToUnifiedLogin();
      return false;
    },
    getTips() {
      this.$http({
        url: "api/v1/system/config/configKey/sys.tips.index",
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.tipsContent = res.data;
        }
      });
    },
    getHotList() {
      this.$http({
        url: "api/v1/reception/journalpaper/getTopSearchWords",
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.hotList = res.data;
        }
      });
    },
    toSearch() {
      if (!this.keyword.trim()) {
        return;
      }
      if (!this.ensureLoginBeforeSearch()) {
        return;
      }
      sessionStorage.removeItem("search-keyword");
      let searchWords = this.keyword.trim();
      sessionStorage.setItem(
        "search-keyword",
        JSON.stringify({
          word: searchWords,
          paper: this.paper,
          searchType: 1,
        }),
      );
      this.keyword = "";
      this.$router.push({
        path: "/article",
      });
    },
    toHotSearch(word) {
      if (!this.ensureLoginBeforeSearch()) {
        return;
      }
      sessionStorage.setItem(
        "search-keyword",
        JSON.stringify({
          word: word.trim(),
          paper: this.paper,
          searchType: 1,
        }),
      );
      this.keyword = "";

      this.$router.push({
        path: "/article",
      });
    },
    getKeywordData() {
      this.selectVal = "";
      const currentKeyword = this.keyword;
      if (!currentKeyword.trim()) {
        this.searchFlag = false;
        return;
      }
      let postBody = {
        word: currentKeyword,
        autoCompletionFieldName: this.selectVal,
      };
      this.$http({
        url: `api/v1/reception/journalpaper/suggestion`,
        method: "post",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          if (res.data.length == 0) {
            this.searchFlag = false;
          } else {
            this.keywordDataList = res.data;
            this.searchFlag = true;
          }
        }
      });
    },
    toSearchKeyword(index) {
      if (!this.ensureLoginBeforeSearch()) {
        return;
      }
      sessionStorage.removeItem("search-keyword");
      let searchWords = this.keywordDataList[index].suggestionWord.split("<span style='color:#15babc'>").join("").split("</span>").join("");
      sessionStorage.setItem(
        "search-keyword",
        JSON.stringify({
          word: searchWords,
          paper: this.paper,
          searchType: 1,
        }),
      );
      this.keyword = "";
      this.$router.push({
        path: "/article",
      });
      this.searchFlag = false;
    },
    showSearchInput() {
      if (this.keyword && this.keywordDataList.length > 0) {
        this.searchFlag = true;
      }
    },
    hideSearchInput() {
      setTimeout(() => {
        this.searchFlag = false;
      }, 200);
    },
  },
};
</script>

<style lang="scss" scoped>
.bg {
  height: 100vh;
  background: linear-gradient(rgb(255, 255, 255) 0%, rgba(232, 240, 254, 0.5) 100%);
  margin: 0;
  padding: 0;
}
.literature-search {
  max-width: 800px;
  margin: auto auto 10vh;
  height: 100vh;
  padding-top: 100px;
  .logo_desc {
    margin: 30px auto;
    margin-top: 0;
    color: #358cef;
    font-size: 32px;
    font-weight: 600;
    line-height: 38px;
    letter-spacing: 0;
    text-align: center;
    background: linear-gradient(90deg, #358cef, #3c49dd 50%, #358cef);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  .el-icon-info {
    font-size: 18px;
    color: #ccc !important;
  }
  .item-one {
    border-radius: 10px;
    width: 100%;
    min-height: 60px;
    max-height: 300px;
    background-color: #fff;
    flex-direction: column;
    box-shadow: 0 0 18px 0 rgba(57, 141, 238, 0.12);
    .flex {
      .el-textarea {
        margin-top: 10px;
      }
      ::v-deep .el-textarea__inner {
        font-family: PingFang SC, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue";
        border: none;
        background: none;
        font-size: 16px;
        max-width: 800px;
        resize: none !important;
        overflow-y: scroll;
        scrollbar-width: none;
        height: 60px;
        padding: 5px 15px;
        line-height: 1.5;
      }
    }
    .search-btn {
      cursor: pointer;
      position: relative;
      color: white;
      padding: 10px 20px;
      border: none;
      font-size: 14px;
      transition: background-color 0.3s;
      float: right;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      &.search-btn-active {
        color: #2d8cf0;
        cursor: pointer;
      }

      &.search-btn-disabled {
        color: #ccc;
        cursor: not-allowed;
      }
    }
  }
  .hot {
    display: flex;
    color: #333;
    margin-top: 10px;
    img {
      margin-right: 15px;
      width: 15px;
      height: 19px;
      margin-top: 3px;
    }
    .hot-title {
      margin-right: 10px;
      min-width: 108px;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        margin-left: 0 !important;
        max-width: 760px;
        min-width: 110px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        border-radius: 20px;
        padding: 4px 25px;
        background-color: #fff;
        border: 1px solid #eee;
        color: #333;
        font-size: 16px;
        margin: 5px;
        &:hover {
          color: #2d8cf0;
          border: 1px solid #2d8cf0;
        }
        span {
          cursor: pointer;
        }
      }
    }
  }
}
.search-input {
  position: absolute;
  top: 60%;
  transform: translateY(-45%);
  width: 80%;
  max-width: 800px;
  max-height: 300px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  ul {
    margin: 0;
    padding: 0;
    li {
      padding: 8px 16px;
      cursor: pointer;
      transition: background-color 0.2s;
      display: flex;
      align-items: center;
      gap: 8px;
      .el-icon-search {
        color: #15babc;
        font-size: 16px;
      }
      &:hover {
        background-color: #f5f7fa;
      }
    }
  }
}
</style>
<style lang="scss">
// .el-select-dropdown .el-select-dropdown__item {
//   font-size: 16px;
// }

.el-popover {
  white-space: pre-wrap;
}
</style>
